exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".customized-checkbox.yxt-checkbox[data-v-6c73af2c]:last-of-type{margin-right:8px}.customized-radio[data-v-6c73af2c]  .yxt-radio__label{padding-left:16px}.disabled[data-v-6c73af2c]{color:#d9d9d9;cursor:not-allowed}\n", ""]);

